<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">首页 / 场馆预定</div>

      <div class="filter_con">
        <div class="f_item">
          <div class="f_label">选择城市</div>
          <div class="f_val">
            <div v-for="(item, index) in cityList" :key="index" :class="{'s_item': currentCityIndex === item.id}"
                 class="v_item" @click="cityClick(item,index)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="f_item">
          <div class="f_label">选择区域</div>
          <div class="f_val">
            <div :class="{'s_item': currentAreaIndex === null}"
                 class="v_item" @click="areaClick(null)">
              全部
            </div>
            <div v-for="(item, index) in selectArea" :key="index" :class="{'s_item': currentAreaIndex === item.id}"
                 class="v_item" @click="areaClick(item.id)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <!--        <div class="f_item">-->
        <!--          <div class="f_label">收费类型</div>-->
        <!--          <div class="f_val">-->
        <!--            <div v-for="(item, index) in feeType" :key="index"-->
        <!--                 :class="{'s_item': feeTypeIndex === index}"-->
        <!--                 class="v_item" @click="feeTypeIndex = index">-->
        <!--              {{ item }}-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="f_item">
          <div class="f_label">运动项目</div>
          <div class="f_val">
            <div
                :class="{'s_item': currentSportsEventsIndex === 0}"
                class="v_item" @click="sportsClick(0)">
              全部
            </div>
            <div v-for="(item, index) in sportsEvents" :key="index"
                 :class="{'s_item': currentSportsEventsIndex === item.id}"
                 class="v_item" @click="sportsClick(item.id)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>

      <div class="v_list">
        <div v-for="(item, index) in venueList" :key="index" class="hover_style v_item" @click="toDetail(item)">
          <div class="v_img">
            <img :src="fileUrl+imageChange(item.pics)" alt="">
          </div>
          <div class="text_overflow v_name">{{ item.name || '-' }}</div>
          <div class="v_info">
            <div class="text_overflow">{{ item.siteNameStr || '-' }}</div>
            <div class="display_flex v_add">
              <img alt="" src="../../assets/image/index/icon_local.png">
              {{ item.address || '-' }}
            </div>
          </div>
        </div>
      </div>

      <div class="display_flex" style="justify-content: center">
        <el-pagination
            :total="total"
            background
            layout="prev, pager, next"
            @current-change="currentChange">
        </el-pagination>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
import { FILE_API } from "@/Settings"

export default {
  name: "venueReservation",

  data () {
    return {
      fileUrl: FILE_API,
      treeList: [],
      // 选择城市
      cityList: [],
      currentCityIndex: 0, // 当前选择城市下标
      // 选择区域
      selectArea: [],
      currentAreaIndex: 0, // 当前选择区域下标
      // 收费类型
      feeType: ['全部', '收费', '邮费', '免费'],
      feeTypeIndex: 0, // 当前报名状态下标
      // 运动项目
      sportsEvents: ['所有项目', '羽毛球', '乒乓球', '篮球', '足球', '网球', '游泳', '健身', '台球', '跆拳道', '瑜伽', '田径场', '冰雪运动', '保龄球', '飞镖', '门球', '射箭', '羽毛球', '排球', '广场舞', '拳击'],
      currentSportsEventsIndex: 0, // 当前选择区域下标

      // 场馆列表
      venueList: [],
      total: 0,
      current: 1
    }
  },
  created () {
    this.getArea()
    this.projectAjax()
  },
  methods: {
    imageChange (url) {
      let imgList = url && url.split(',')
      return imgList && imgList[0]
    },
    cityClick (item) {
      this.currentCityIndex = item.id
      let info = this.treeList.find(e => e.id === item.id)

      this.selectArea = info.children
      this.currentAreaIndex = null
      this.menhuAjax()
    },
    areaClick (item) {
      this.currentAreaIndex = item
      this.menhuAjax()
    },
    sportsClick (item) {
      this.currentSportsEventsIndex = item
      this.menhuAjax()
    },
    toDetail (item) {
      this.$router.push({ path: '/venueDetail', query: { id: item.id } })
    },
    // 省市区
    getArea () {
      this.$postAction('dict-area/tree').then((res) => {
        this.cityList = res.data[0].children
        this.treeList = res.data[0].children
        this.selectArea = this.cityList[0].children
        this.currentCityIndex = this.cityList[0].id
        this.currentAreaIndex = null
        this.menhuAjax()
      })
    },
    // 场馆项目
    projectAjax () {
      this.$postAction('gateway/venue-projects/list').then((res) => {
        this.sportsEvents = res.data
        this.currentSportsEventsIndex = 0
      })
    },
    currentChange (e) {
      this.current = e
      this.menhuAjax()
    },
    // 场馆
    menhuAjax () {
      this.$postAction('gateway/venue-table/menhu_page', {
        "page": {
          "current": this.current,
          "size": 10
        },
        "data": {
          "cityId": this.currentCityIndex,
          "areaId": this.currentAreaIndex,
          "projectId": this.currentSportsEventsIndex
        }
      }).then((res) => {
        this.venueList = res.data.records.map(item => {
          item.siteNameStr = item.siteNames ? item.siteNames.replaceAll(',', ' | ') : ''
          return item
        })
        this.total = res.data.total
      })
    }
  }
}
</script>

<style lang="less" scoped>
.center_container {
  padding-bottom: 40px;

  .v_list {
    padding: 52px 0 40px;
    display: flex;
    flex-wrap: wrap;

    .v_item {
      width: calc((100% - 72px) / 4);
      margin-right: 16px;
      margin-bottom: 16px;
      background: #FFFFFF;
      border: 1px solid #DCDCDC;


      &:nth-child(4n) {
        margin-right: 0;
      }

      .v_img {
        height: 228px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .v_name {
        font-weight: 500;
        font-size: 24px;
        background: #0058A6;
        padding: 17px 24px;
        color: #ffffff;
      }

      .v_info {
        padding: 16px 20px;
        font-size: 16px;

        .v_add {
          margin-top: 24px;
          justify-content: start;

          img {
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>
